import React from 'react';
import { Tag } from 'antd';

export const statusTiersPrestationLabelMap: { [statusTiers: string]: string } = {
    10: 'Intégré',
    20: 'En attente de validation',
    30: 'Validé',
    40: 'Refusé',
    50: 'Prélevé',
    70: 'Payé'
};

export const statusTiersPrestationColorMap: { [statusTiers: string]: string | undefined } = {
    10: 'blue',
    20: 'orange',
    30: 'green',
    40: 'red',
    50: 'green',
    70: "green"
};

export default function StatusTiersPrestationTag({
                                                     statusTiers
                                                 }: { statusTiers: string | number }) {

    const key = String(statusTiers);

    return (
        <Tag color={statusTiersPrestationColorMap[key]}>
            {statusTiersPrestationLabelMap[key] || 'Inconnu'}
        </Tag>
    );
}